import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import LattesIcon from "./fotosMembros/lattes_img.png";

const CardSlider = ({ membros }) => {
  console.log('Membros:', membros);

  if (!Array.isArray(membros)) return <p>Erro: membros não é um array.</p>;

  return (
    <section className="w-full h-[50vh] max-w-[180vh] mx-auto p-[20px] max-[480px]:w-[90%] max-[480px]:p-[10px]">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        centeredSlides={membros.length === 1}
        centerInsufficientSlides={true}
        navigation
        pagination={{ clickable: true, dynamicBullets: true }}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 5 },
        }}
      >
        {membros.map(({ id, name, role, img, lattes }) => (
          <SwiperSlide key={id}>
            <article className="bg-[linear-gradient(to_right,rgba(106,13,173,0.4),rgba(255,102,178,0.4))] p-[15px] rounded-[10px] shadow-[0_4px_6px_rgba(0,0,0,0.1)] text-center w-[300px] h-[350px]">
              <div className="flex justify-center items-center relative">
                <img src={img} alt={name} className="w-[200px] h-[200px] rounded-full border-[2px] border-[#007bff]" />
                <div className="card__shadow"></div>
              </div>
              <div className="card__data">
                <h3 className="text-[18px] my-[10px]">{name}</h3>
                <p>{role}</p>
                {lattes && (
                  <div className="flex justify-center">
                    <a
                      href={lattes}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={LattesIcon}
                        alt="Lattes"
                        width={30}
                        height={30}
                        className="mt-[10px]"
                      />
                    </a>
                  </div>
                )}
              </div>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default CardSlider;
